export default "__VITE_ASSET__B29qBg0I__"